import React from "react";
import './ScientiaFooter.less';
import logo from "../images/EMSL_0541_BRAND_ScientiaLogo_FullLogo_ColorReversed.svg";
import white_emsl from '../images/White_EMS_ logo.svg';
import linkedin from '../images/linkedin.svg';
import facebook from '../images/facebook.svg';
import instagram from '../images/instagram.svg';
import youtube from '../images/youtube-svgrepo-com.svg';
import xplatform from  '../images/x-social-media-black-icon.svg';

interface Props  {
    onExternalLinkClick: (url: string) => void;
  };

const ScientiaFooter: React.FC<Props> = ({onExternalLinkClick}) => {

    const handleExternalLinkClick = (url: string, e: React.MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault();
        onExternalLinkClick(url);
      };
    
    const handleProposalClick = (e: any) => {
      handleExternalLinkClick(process.env.REACT_APP_PROPOSAL_MANAGEMENT as string, e);
    }

    const handleLIMSClick = (e: any) => {
      handleExternalLinkClick('LIMS_CARDS', e);
    }
  
    const handleDataPortalClick = (e: any) => {
      handleExternalLinkClick(process.env.REACT_APP_DATA as string, e);
    }
    
    const handleWorkBenchClick = (e: any) => {
      handleExternalLinkClick('MODELING_WORKBENCH_CARDS', e);
    }  
    const handleInsightClick = (e: any) => {
      handleExternalLinkClick('INSIGHT_ENGINE_CARDS', e);
    }
    
    return (
        <div className="scientia-footer">
            <div className="footer-frame">
                <div className="footer-left">
                    <div className="footer-logo-frame">
                        <a href="https://www.emsl.pnnl.gov/" target="_blank" rel="noopener noreferrer">
                            <img className="footer-logo" style={{width: "150px", height: "85px", marginTop: "-10px"}} src={white_emsl} alt = "logo" />
                        </a>
                        <p className="separator">|</p>
                        <img className="footer-logo" style={{marginLeft: "10px"}} src={logo} alt="logo" />
                    </div>
                    <div className="footer-logo-group">

                    <a className="icon-cont" href="https://www.linkedin.com/company/environmental-molecular-sciences-laboratory-emsl-" target="_blank" rel="noopener noreferrer">
                    <img className="icon" src={linkedin} alt="linkedin" />
                    </a>

                    <a className="icon-cont" href="https://twitter.com/EMSLscience" target="_blank" rel="noopener noreferrer">
                    <img className="icon" src={xplatform} alt="x" />
                    </a>

                    <a className="icon-cont" href="https://www.facebook.com/emsl.pnnl.gov" target="_blank" rel="noopener noreferrer">
                    <img className="icon" src={facebook} alt="facebook" />
                    </a>

                    <a className="icon-cont" href="https://www.instagram.com/emslscience/" target="_blank" rel="noopener noreferrer">
                    <img className="icon" src={instagram} alt="instagram" />
                    </a>

                    <a className="icon-cont" href="http://www.youtube.com/user/EMSLatPNNL" target="_blank" rel="noopener noreferrer">
                    <img className="icon" src={youtube} alt="youtube" />
                    </a>
                    </div>
                <div>
            </div>
               
         </div>
                <div className="footer-right">
                    <div className="footer-right-frame">
                        <div className="link-col1">   
                            <a href={process.env.REACT_APP_ABOUT} target="_blank" rel="noopener noreferrer" className="footer-links">Our Mission</a>
                            <a href={process.env.REACT_APP_EMSL_PROPOSAL_CALLS} target="_blank" rel="noopener noreferrer" className="footer-links">Proposal Calls</a>
                            <a href={process.env.REACT_APP_EMSL_LEARNING} target="_blank" rel="noopener noreferrer" className="footer-links">EMSL LEARN</a>
                            <a href={process.env.REACT_APP_CONTACT} target="_blank" rel="noopener noreferrer" className="footer-links">Contact Us</a>
                        </div>
                        <div className="link-col2">
                            <button className="footer-links" onClick={handleProposalClick} style={{ padding: '0px'}}>Proposal Management</button>
                            <button className="footer-links" onClick={handleLIMSClick} style={{ padding: '0px'}}>LIMS</button>
                            <button className="footer-links" onClick={handleDataPortalClick} style={{ padding: '0px'}}>Data</button>
                            <button className="footer-links" onClick={handleWorkBenchClick} style={{ padding: '0px'}}>Modeling Workbench</button>
                            <button className="footer-links" onClick={handleInsightClick} style={{ padding: '0px'}}>Insight Engine</button>
                        </div>    
                        <div className="link-col3">
                            <a href={process.env.REACT_APP_TOS} target="_blank" rel="noopener noreferrer" className="footer-links">Acknowledge EMSL</a>
                            <a href={process.env.REACT_APP_DATA_POLICY} target="_blank" rel="noopener noreferrer" className="footer-links">Data Management Policy</a>
                            <a href={process.env.REACT_APP_PRIVACY_POLICY} target="_blank" rel="noopener noreferrer" className="footer-links">Security and Privacy</a>
                        </div>
                    </div>                   
                </div>
            </div>
        </div>
      );
}

export default ScientiaFooter